import React from "react";

import { cn } from "@/utils/shadcn-ui";

export function FormGrid({
  children,
  columns = 2,
  className,
}: {
  children?: React.ReactNode;
  columns?: number;
  className?: string;
}) {
  return (
    <div
      // The column count rides in a CSS var rather than an inline
      // `grid-template-columns`: an inline style outranks every class, so a
      // `max-sm:` override could never collapse the grid on a phone.
      className={cn(
        "grid gap-x-6 gap-y-4 grid-cols-[repeat(var(--form-grid-columns),minmax(0,1fr))] max-sm:grid-cols-1",
        className,
      )}
      style={{ "--form-grid-columns": columns } as React.CSSProperties}
    >
      {children}
    </div>
  );
}
